import type { Quest } from '@athrelaris/shared';
import { questListeningStone } from './quest-01-listening-stone.js';

export const QUESTS: Record<string, Quest> = {
  [questListeningStone.id]: questListeningStone,
};

export function getQuest(id: string): Quest | null {
  return QUESTS[id] ?? null;
}
